import React, { Component } from 'react';
import features from './features';

class Home extends Component {

    renderFeatures = () => {
        return features.map(feature => {
            return (
                <div key={feature.id}>
                    <div className='boxes'>
                    <h5><i className={feature.icon}></i> {feature.name}</h5>
                    <p className='content' >{feature.content}</p>
                    </div>
                </div>
            )
        })
    }

    render() {
        return (
            <div id='container'>
                {this.renderFeatures()}
            </div>
        );
    }
}

export default Home;